import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getItem } from '../../../../utils/localStorage';
import { toastify } from '../../../../utils/toast';
import Layout from '../../component/layout';
import { makeRequest2 } from '../../../../utils/makeRequest';
import { getFAQ, editFAQ } from '../../../../utils/urls'; // add getFAQ endpoint

const EditFaq = () => {
    const navigate = useNavigate();
    const { faqId } = useParams(); // use faqId from URL parameters

    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');

    const fetchFaqData = async () => {
        try {
            const response = await makeRequest2(getFAQ + '/' + faqId, 'GET', {});
            if (response.success) {
                setQuestion(response.data.question);
                setAnswer(response.data.answer);
            } else {
                throw new Error(response.error || 'Failed to load FAQ details');
            }
        } catch (err) {
            toastify(err.message, 'error');
        }
    };

    const handleEdit = async () => {
        try {
            const faq = { question, answer };
            const response = await makeRequest2(editFAQ + '/' + faqId, 'POST', faq);
            if (response.success) {
                toastify(response.data, 'success');
                navigate('/faq');
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error');
        }
    };

    const handleClear = () => {
        setQuestion('');
        setAnswer('');
    };

     useEffect(() => {
        fetchFaqData();
    }, []);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/app/">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="#">Visitor & Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="#">FAQs</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="#">Edit FAQ</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <Link to="#" onClick={() => navigate(-1)}>
                                <span>
                                    <i className="ti ti-arrow-narrow-left"></i> Back
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Edit FAQ</h5>
                        </div>

                        <div className="card-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Question</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="4"
                                                value={question}
                                                onChange={(e) => setQuestion(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Answer</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="4"
                                                value={answer}
                                                onChange={(e) => setAnswer(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="text-end">
                                <button type="button" className="btn btn-outline-secondary" onClick={handleClear}>
                                    Clear
                                </button>
                                &nbsp;
                                <button type="button" className="btn btn-primary" onClick={handleEdit}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default EditFaq;
